import { GraduationCap, Target, Zap, ShieldCheck } from "lucide-react";
const benefits = [{
  title: "Expert Research",
  description: "Our team does extensive research, analyzing technical specs and security protocols to find the best protection.",
  icon: GraduationCap
}, {
  title: "Research-driven testing",
  description: "We research technical specs, safety protocols, and verified owner reviews to find the best protection.",
  icon: Target
}, {
  title: "Family Safety Focus",
  description: "Every recommendation is filtered through the lens of protecting what matters most: your loved ones and home.",
  icon: ShieldCheck
}, {
  title: "Updated Reviews",
  description: "The smart home world moves fast. We constantly refresh our data to ensure you have the latest security insights.",
  icon: Zap
}];
export default function WhyFamiliesTrustSafebode() {
  return <section data-section-id="259133" id="why-families-trust-safebode" className="dark py-32 bg-primary border-y border-border/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {benefits.map((benefit, i) => {
          const Icon = benefit.icon;
          return <div key={i} data-index={i} className="flex flex-col items-center text-center group">
                <div className="mb-5 p-4 rounded-lg bg-secondary/10 text-secondary group-hover:bg-secondary group-hover:text-secondary-foreground transition-colors duration-300">
                  <Icon className="w-12 h-12" strokeWidth={1.5} />
                </div>
                <h3 className="text-xl font-bold font-default text-foreground mb-3 tracking-tight">
                  {benefit.title}
                </h3>
                <p className="text-base font-default text-[hsl(210,10%,85%)] leading-relaxed">
                  {benefit.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}